import { render } from "./Footer.vue?vue&type=template&id=106066e8"
const script = {}

import exportComponent from "/home/user/mydid-pdf-demo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__